import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ActWhiteBlock ActContentBlock" }
const _hoisted_2 = { class: "ActDashboardContentWrapper" }
const _hoisted_3 = { class: "ActDashboardTextWrapper" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "ActDashboardTitle" }, " Empower Your Institution with Data-Driven Decisions ", -1 /* CACHED */)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "ActDashboardText" }, " Our dashboards transform complex student demand and supply data into clear, practical insights, helping you identify market opportunities, understand mobility patterns, and stay ahead of emerging trends. ", -1 /* CACHED */)),
        _createElementVNode("button", {
          class: "ChampionButton ActDashboardButton",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleRequestDemoClick && _ctx.handleRequestDemoClick(...args)))
        }, " Request a Demo ")
      ]),
      _createElementVNode("img", {
        class: "ActDashboardImage ActDashboardBannerImage",
        src: `${_ctx.monetUrl}banner_active_dashboards.png`,
        alt: "ACT Data Visualisation"
      }, null, 8 /* PROPS */, _hoisted_4)
    ])
  ]))
}